import { ClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/click.trackingInfo";

import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsButtonImpression,
    getGoogleAnalyticsButtonImpression
} from "./GoogleAnalyticsButtonImpression";

export interface GoogleAnalyticsLinkClick
    extends GoogleAnalyticsButtonImpression {}

const getGoogleAnalyticsLinkClick = (
    data: TypedAnalyticsEvent<ClickTrackingInfo>
): GoogleAnalyticsLinkClick => {
    return getGoogleAnalyticsButtonImpression(
        data,
        GoogleAnalyticsEvents.LinkClick
    );
};

export { getGoogleAnalyticsLinkClick };
